var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.pCurrentPage,"page-sizes":[10, 20, 50, 100],"page-size":_vm.pPageSize,"layout":_vm.getLayout,"total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }